import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { pickVideoId, SIDEBAR_VIDEO } from '@shared/config/instructions'
import { VideoPlayerDialog, VideoPreview } from '@shared/ui'

export function SidebarVideoCard() {
  const { t, i18n } = useTranslation('participant')
  const [open, setOpen] = useState(false)

  const videoId = pickVideoId(SIDEBAR_VIDEO.videoIds, i18n.language)

  const handleOpenChange = useCallback((next: boolean) => {
    setOpen(next)
  }, [])

  return (
    <>
      <VideoPreview
        videoId={videoId}
        alt={t('sidebar.video_tutorial')}
        onClick={() => setOpen(true)}
        caption={
          <span className="text-xs font-medium text-white">{t('sidebar.video_tutorial')}</span>
        }
      />
      <VideoPlayerDialog
        videoId={videoId}
        title={t('sidebar.video_tutorial')}
        open={open}
        onOpenChange={handleOpenChange}
      />
    </>
  )
}
